import { DateTime } from 'luxon';
import { PaymentStatus, PaymentStatusEnum } from '../licences/PaymentStatus';
import { LicenseTachoModule } from '../modules/LicenseTachoModule';
import { LicenseTypeEnum } from '../licences/LicenseType';

export type AddLicenseVersion = {
    licenseNumber: string;
    validFrom: DateTime;
    validTo: DateTime;
    paymentDeadline: DateTime;
    maximumNumberOfSupportedCars: number;
    allowedModules: Array<LicenseTachoModule>;
    paymentStatus: PaymentStatusEnum;
    type: LicenseTypeEnum;
    noCarsLimit?: boolean;
    includeBeta?: boolean;
    distributorId?: string | null;
    notes: string;
};

export type AddLicenseVersionApi = {
    licenseNumber: string;
    validFrom: string;
    validTo: string;
    paymentDeadline: string;
    maximumNumberOfSupportedCars: number;
    allowedModules: Array<LicenseTachoModule>;
    paymentStatus: PaymentStatus;
    includeBeta: boolean;
    type: LicenseTypeEnum;
    distributorId?: string | null;
    notes: string;
};

export const defaultAddLicenseModel: AddLicenseVersion = {
    licenseNumber: '',
    validFrom: DateTime.fromISO(''),
    validTo: DateTime.fromISO(''),
    paymentDeadline: DateTime.fromISO(''),
    maximumNumberOfSupportedCars: 1,
    allowedModules: [],
    paymentStatus: PaymentStatusEnum.Awaiting,
    type: LicenseTypeEnum.Commercial,
    includeBeta: false,
    notes: '',
};
